<template>
  <div >
    <div class="DataBox">
      <div class="DataTrees">
        <el-input placeholder="输入关键字进行过滤" v-model="filterText">
        </el-input>

        <el-tree
          class="filter-tree"
          :data="treeData"
          :props="defaultProps"
          default-expand-all
          :filter-node-method="filterNode"
          ref="tree"
          @node-click="ClickTree"
        >
        </el-tree>
         <div class="nodesinfor" v-if="isnodesinfor" :v-model="getNodeinfor">
        <img
        style="margin-left: 16px; margin-top: 10px"
        width="80%"
        height="20%"
        :src="this.imgSrc"
        />
        <div class="nodesinfor_s">
        <ul
            v-for="(itme, index) in this.getNodeinfor[0]"
            :key="index"
            style="margin-left: 5px"
        >
            <li style="margin-left: 5px; list-style: none">
            <span style="color: red">{{ index }} :</span>
            <span> {{ itme }}</span>
            </li>
        </ul>
        </div>
        </div>
      </div>
      <div id="mountNode"></div>
       
    </div>
  </div>
</template>

<script>
import G6 from "@antv/g6";
import Data from "./military_1.json";
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      isnodesinfor: false,
      getNodeinfor: [],
      imgSrc: "",
      //   RELATIONS: stringfyKeys(RELATIONS, ["head", "rel", "person2_id"]),
      DataGraphs: {
        nodes: [
          //   {
          //     id: "Mitigation",  节点id必须唯一
          //     label: "Mitigation",
          //     x: 200,
          //     y: 50,
          //   },
          //   {
          //     id: "node3",
          //     label: "node3",
          //     x: 200,
          //     y: 50,
          //   },
          //   {
          //     id: "node4",
          //     label: "node4",
          //     x: 300,
          //     y: 150,
          //   },
        ],
        edges: [
          // 带有箭头的边，内置箭头
          //   {
          //     source: "",  起点id
          //     target: "",  终点id
          //     label: "",   边的信息
          //     style: {
          //       endArrow: true,
          //     },
          //     labelCfg: {
          //       autoRotate: true,
          //       refY: 10,
          //     },
          //   },
        ],
      },
      graph: "",
      NodeTail: "",
      deNode: "",
      filterText: "",
      treeData: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },
  computed: {},
  created() {},
  mounted() {
    // console.log(Data);
    // this.ModifyData();
    this.getTreeNodes();
    // this.getTreeNodes();
  },
  watch: {
    filterText(val) {
      //左侧查询点的方法
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    ClickTree(e) {
      //搜索结果点击
      console.log(e);
      // alert(e);
      const treeID = e.id;
      this.treeDatasFliter(treeID);
    },
    /**
     * 搜索结果右击方法
     */
    treeDatasFliter(id) {
      //根据类别获取相关节点信息
      this.DataGraphs.nodes = [];
      // 找到所有相关类型的数据，然后再取所有类型数据中的名称作为实体
      const DataNodesA = Data.filter((x) => x.类型 == id);
      const Datafrom = []; //产国节点
      const DataName = []; //名称节点——主节点
      const DataBigType = []; //大类节点
      const DataType = []; //类型节点
      const RDunit = []; //研发单位节点
      for (var i = 0; i < DataNodesA.length; i++) {
        Datafrom.push(DataNodesA[i].产国);
        DataName.push(DataNodesA[i].名称);
        DataBigType.push(DataNodesA[i].大类);
        DataType.push(DataNodesA[i].类型);
        RDunit.push(DataNodesA[i].研发单位);
      }
      // 全部融合在一起 然后去重
      const DataCollections1 = [
        ...Datafrom,
        ...DataName,
        ...DataBigType,
        ...DataType,
        ...RDunit,
      ];
      const DataCollections2 = this.array_deduplication(DataCollections1);
      const DataCollections = [];
      DataCollections2.forEach((res) => {
        if (res) {
          DataCollections.push(res);
        }
      });
      // 将整理好的数据变成节点
      for (let index = 0; index < DataCollections.length; index++) {
        this.DataGraphs.nodes.push({
          id: DataCollections[index],
          label: DataCollections[index],
          // shape: "image",
          // img: "http://images.huanqiu.com/sarons/2014/01/11d37265ef4b71dc65ee48503c5b8709.jpg",
        });
      }
      // 生成关系
      const sourceSet1 = []; //名称->产国
      const sourceSet2 = []; //名称->研发单位
      const sourceSet3 = []; //名称->飞行器：大类
      const sourceSet4 = []; //名称->攻击机：类型
      for (var i = 0; i < DataNodesA.length; i++) {
        sourceSet1.push({
          source: DataNodesA[i].名称,
          target: DataNodesA[i].产国,
          tail: "产国",
        });
        sourceSet2.push({
          source: DataNodesA[i].名称,
          target: DataNodesA[i].研发单位,
          tail: "研发单位",
        });
        sourceSet3.push({
          source: DataNodesA[i].名称,
          target: DataNodesA[i].大类,
          tail: "大类",
        });
        sourceSet4.push({
          source: DataNodesA[i].名称,
          target: DataNodesA[i].类型,
          tail: "类型",
        });
      }
      this.DataGraphs.edges = [
        ...sourceSet1,
        ...sourceSet2,
        ...sourceSet3,
        ...sourceSet4,
      ];
      // console.log("关系", sourceSet);
      //graph 生成节点的方法
      this.graph.clear(); //销毁渲染
      this.graph.data(this.DataGraphs); // 创建
      console.log(this.DataGraphs,'this.DataGraphs');
      this.graph.render();
    },
    /**
     * 展示所有节点树形态
     */
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    /**
     * 获取所有节点实体信息
     */
    getTreeNodes() {
      // for (var i = 0; i < Data.length; i++) {
      //   dataTypes.push(Data[i].大类);
      // }
      const datatypes = [];
      for (var i = 0; i < Data.length; i++) {
        datatypes.push(Data[i].类型);
      }
      const datatypes1 = this.array_deduplication(datatypes);
      for (var j = 0; j < datatypes1.length; j++) {
        this.treeData.push({
          id: datatypes1[j],
          label: datatypes1[j],
        });
      }
      // console.log("大类", this.treeData);
      this.LoadGraph();
    },
    LoadGraph() {
      this.graph = new G6.Graph({
        container: "mountNode",
        // fitView: true,
        modes: {
          default: [
            "drag-canvas",
            "zoom-canvas",
            "drag-node",
            {
              type: "activate-relations",
              trigger: "click",
            },
          ], // 允许拖拽画布、放缩画布、拖拽节点、设置高亮
        },
        defaultEdge: {
          //边
          color: "#bae7ff",
          // label: 123, //边线的文字
          labelCfg: {
            refX: -5,
            fill: "blue",
          },
          style: {
            endArrow: true,
          },
          labelCfg: {
            autoRotate: true,
            refY: 10,
          },
        },
        layout: {
          type: "force",
          preventOverlap: true,
          nodeStrength: -200,
          minMobement: 0.1,
          unitRadius: 200,
          linkDistance: 150,
          center: [500, 300],
        },
        defaultNode: {
          // type: "image",
          size: [50, 20],
          labelCfg: {
            style: {
              fill: "5B8FF9",
              fontsize: 10,
            },
          },
        },
      });
      this.graph.data(this.DataGraphs);
      this.graph.render();
      this.graph.on("edge:mouseenter", (e) => {
        const that = this;
        that.deNode = e.item._cfg.id;
        that.NodeTail = e.item._cfg.model.tail;
        // console.log("123", that.deNode, e.item._cfg.model.tail);
        that.EditEdge(that.deNode);
      });
      this.graph.on("edge:mouseleave", (e) => {
        const that = this;
        // console.log(e);
        // const deNode = e.item._cfg.id;
        that.delateEdge(that.deNode);
      });
      // this.graph.on("node:dblclick", (e) => {
      //   console.log(e);
      //   const nodeId = e.item._cfg.id;
      //   if (e.item._cfg.edges.length == 0) {
      //     return;
      //   } else {
      //     var targetId = e.item._cfg.edges[0]._cfg.target._cfg.id;
      //   }

      //   this.DataMap(nodeId, targetId);
      //   console.log(targetId);
      //   // const person = this.PERSONS_MAP[nodeId];
      //   // this.appendGraphDataViaNode(this.graphData, person);
      //   // this.graph.refresh();
      //   // this.graph.render();
      // });
      //单击节点展示信息
      this.graph.on("node:click", (e) => {
        console.log(e.item._cfg.id);
        this.isnodesinfor = true;
        const nodeInforId = e.item._cfg.id;
        this.getNoderInfor(nodeInforId);
        // debugger;
        // console.loge.item._cfg.edges[]);
        // const edgeDatas = [];
        // for (var i = 0; i < e.item._cfg.edges.length; i++) {
        //   edgeDatas.push(e.item._cfg.edges[i]._cfg.model.tail);
        // }
        // this.NodeTail = edgeDatas;
        // // console.log("123", that.deNode, e.item._cfg.model.tail);
        // this.EditEdge(nodeInforId);
      });
    },
    // 查看单个节点信息
    getNoderInfor(id) {
      this.getNodeinfor = [];
      this.imgSrc = "";
      const getNodeinfor1 = Data.filter((x) => x.名称 == id);
      // console.log(getNodeinfor);
      if (getNodeinfor1.length !== 0) {
        this.imgSrc = getNodeinfor1[0].图片;
        for (var i = 0; i < getNodeinfor1.length; i++) {
          // console.log(getNodeinfor1[i]);
          // delete getNodeinfor1[i]._id;

          this.getNodeinfor.push(getNodeinfor1[i]);
          // console.log(getNodeinfor1[i]);
        }
        this.getNodeinfor.map((item) => {
          // delete getNodeinfor1[i].图片;
        });
      }
    },
    array_deduplication(arr) {
      //数组去重方法
      return arr.filter(function (c, index) {
        return arr.indexOf(c) === index;
      });
    },

    ModifyData() {
      //初始加载全部节点数据
      this.FilterData();
    },
    EditEdge(item) {
      this.graph.update(item, {
        label: this.NodeTail,
      });
    },
    delateEdge(item) {
      this.graph.update(item, {
        label: "",
      });
    },
    FilterData() {
      //初始加载的数据
      const DataGraphsedgesTail = [];
      // 获取中间点所有'CyberThing'的关系
      const DataGraphsedgesCyberThing1 = this.DataGraphs.edges.filter(
        (x) => x.source == "CyberThing"
      );
      const DataGraphsedgesCyberThing2 = this.DataGraphs.edges.filter(
        (x) => x.target == "CyberThing"
      );
      const NewedgesCyberThing = [
        ...DataGraphsedgesCyberThing1,
        ...DataGraphsedgesCyberThing2,
      ];
      // 获取中间点所有'ATTCK'的关系
      const DataGraphsedgesATTCK1 = this.DataGraphs.edges.filter(
        (x) => x.source == "ATTCK"
      );
      const DataGraphsedgesATTCK2 = this.DataGraphs.edges.filter(
        (x) => x.target == "ATTCK"
      );
      const NewedgesATTCK = [
        ...DataGraphsedgesATTCK1,
        ...DataGraphsedgesATTCK2,
      ];
      this.DataGraphs.edges = [];
      this.DataGraphs.edges = [...NewedgesCyberThing, ...NewedgesATTCK]; //将要展示的二者的关系合并
      // console.log("过滤数据边1", newATTCKandCyberThing);
      const datahead = [];
      const datarel = [];
      for (var b = 0; b < this.DataGraphs.edges.length; b++) {
        // console.log(b);
        datahead.push(this.DataGraphs.edges[b].source);
        datarel.push(this.DataGraphs.edges[b].target);
      }
      const x = this.array_deduplication([...datahead, ...datahead]);
      for (var i = 0; i < x.length; i++) {
        this.DataGraphs.nodes.push({
          id: x[i],
          label: x[i],
        });
      }
      // this.DataGraphs.nodes.push({
      //   id: "isA",
      //   label: "isA",
      // });
      console.log("过滤数据边2", this.DataGraphs);
      this.LoadGraph();
    },
    DataMap(id, targetId) {
      const NewGraphsedges = []; //获取所有的边
      const Graphsnodes = []; //获取所有的点
      for (var a = 0; a < Data.length; a++) {
        NewGraphsedges.push({
          source: Data[a].head,
          target: Data[a].tail,
          tail: Data[a].tail,
        });
      }
      const DataNodesRel = Data.map((x) => {
        x = x.tail;
        return x;
      });
      const DataNodesHead = Data.map((x) => {
        x = x.head;
        return x;
      });
      const x = this.array_deduplication([...DataNodesRel, ...DataNodesHead]);

      for (var i = 0; i < x.length; i++) {
        Graphsnodes.push({
          id: x[i],
          label: x[i],
        });
      }
      // debugger;
      const NewDataGraphsedges1 = NewGraphsedges.filter((x) => x.source == id); //点击节点过滤后的所有的边
      const NewDataGraphsedges2 = NewGraphsedges.filter((x) => x.target == id);
      const NewDataGraphsedges = [
        ...NewDataGraphsedges1,
        ...NewDataGraphsedges2,
      ];
      // console.log("222", NewDataGraphsedges);
      const Graphshead = [];
      const Graphsrel = [];
      for (var b = 0; b < NewDataGraphsedges.length; b++) {
        // console.log(b);
        Graphshead.push(NewDataGraphsedges[b].source);
        Graphsrel.push(NewDataGraphsedges[b].target);
      }
      const MapGraph = this.array_deduplication([...Graphshead, ...Graphsrel]);
      const GraphNodes = []; //获取所有相关过滤后的节点
      for (var i = 0; i < MapGraph.length; i++) {
        GraphNodes.push({
          id: MapGraph[i],
          label: MapGraph[i],
        });
      }
      const NewDataGraphNodes1 = GraphNodes.filter((x) => x.id !== id);
      const NewDataGraphNodes = NewDataGraphNodes1.filter(
        (x) => x.id !== targetId
      );
      console.log("push前", this.DataGraphs.nodes);
      for (var i = 0; i < NewDataGraphNodes.length; i++) {
        this.DataGraphs.nodes.push({
          id: NewDataGraphNodes[i].id,
          label: NewDataGraphNodes[i].id,
        });
      }
      console.log("push后", this.DataGraphs.nodes);
      // const Graphsedges = NewDataGraphsedges.filter(
      //   (x) => x.target !== targetId
      // );
      for (var i = 0; i < NewDataGraphsedges.length; i++) {
        this.DataGraphs.edges.push({
          source: NewDataGraphsedges[i].source,
          target: NewDataGraphsedges[i].target,
          tail: NewDataGraphsedges[i].tail,
        });
      }
      // this.graph.clear();
      this.graph.data(this.DataGraphs);
      this.graph.render();
      console.log("点击后关系", Graphsedges);
    },
  },
};
</script>

<style >
body {
  background-color: #bec7d5 !important;
}
</style>
<style  scoped>
* {
  margin: 0px;
  padding: 0px;
}
.nodesinfor_s {
  height: 76%;
  overflow: auto;
}
.nodesinfor_s::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.DataBox {
  display: flex;
  justify-content: space-between;
  position: relative;
  /* overflow: hidden; */
}
#mountNode {
  /* z-index: 999 !important; */
  width: 85%;
  height:80vh;
}
.DataTrees {
  width: 15%;
  /* height: 800px; */
}
.nodesinfor {
  left:1230px;
  bottom: 170px;
  height: 400px;
  width: 300px;
  background: skyblue;
  position:absolute;
}
.filter-tree::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.DataTrees .filter-tree {
  height: 500px;
  background-color: skyblue;
  overflow: auto;
}
</style>
